import React, { useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faUser, faSignOutAlt, faTachometerAlt, faFolderOpen, faFileInvoiceDollar, faAddressCard, faTrashCan, faHouse } from '@fortawesome/free-solid-svg-icons'

import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import { toast } from 'react-toastify';

export default function EmployeePortal() {
    const { currentUser, logout} = useAuth();
    const navigate = useNavigate();

    const [isSideNavExpanded, setIsSideNavExpanded] = useState(false);

    async function handleLogout(){
        try{
            await logout();
            navigate("/employee-login");
        }catch(error){
            toast.error(`Failed to log out: ${error.message}`);
        }
    }

    return (
        <>
            <SideNav
                expanded = {isSideNavExpanded}
                onSelect = {(selected)=>{
                    setIsSideNavExpanded(false);
                }}
                onToggle={(expanded)=>{
                    setIsSideNavExpanded(expanded);
                }}  
                style={{backgroundColor: '#2596be', position: 'fixed'}}
            >
                <SideNav.Toggle />
                <SideNav.Nav defaultSelected="Main page">
                    <NavItem
                        eventKey="Main page"
                        onClick={()=>{
                            navigate("/");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faHouse} />
                        </NavIcon>
                        <NavText>
                            Home
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="Dashboards">
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faTachometerAlt} />
                        </NavIcon>
                        <NavText>
                            Dashboards
                        </NavText>
                        <NavItem
                            eventKey="Service Requests"
                            onClick={()=>{
                                navigate("/service");
                            }}
                        >
                            <NavText>
                                Service Requests
                            </NavText>
                        </NavItem>
                        <NavItem
                            eventKey="Maintenance"
                            onClick={()=>{
                                navigate("/maintenance");
                                //alert("Maintenance Dashoard - coming soon.");
                            }}
                        >
                            <NavText>
                                Maintenance
                            </NavText>
                        </NavItem>
                        <NavItem
                            eventKey="Installs"
                            onClick={()=>{
                                navigate("/construction");
                            }}
                        >
                            <NavText>
                                Construction
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem
                        eventKey="Finalized"
                        onClick={()=>{
                            navigate("/finalized");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faFolderOpen} />
                        </NavIcon>
                        <NavText>
                            Finalized
                        </NavText>
                    </NavItem>
                    <NavItem
                        eventKey="Invoiced"
                        onClick={()=>{
                            navigate("/invoiced");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faFileInvoiceDollar} />
                        </NavIcon>
                        <NavText>
                            Invoiced
                        </NavText>
                    </NavItem>
                    <NavItem
                        eventKey="Client Information"
                        onClick={()=>{
                            navigate("/client_information");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faAddressCard} />
                        </NavIcon>
                        <NavText>
                            Client Information
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="Settings">
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCog} />
                        </NavIcon>
                        <NavText>
                            Settings
                        </NavText>
                        <NavItem
                            eventKey="AdminSettings"
                            onClick={()=>{
                                navigate("/admin-settings");
                            }}
                        >
                            <NavText>Admin Settings</NavText>
                        </NavItem>
                        <NavItem
                            eventKey="TechSettings"
                            onClick={()=>{
                                navigate("/tech-settings");
                            }}
                        >
                            <NavText>Tech Settings</NavText>
                        </NavItem>
                        <NavItem
                            eventKey="ClientSettings"
                            onClick={()=>{
                                navigate("/client-settings");
                            }}
                        >
                            <NavText>Client Settings</NavText>
                        </NavItem>
                        <NavItem
                            eventKey="DefaultRateSettings"
                            onClick={()=>{
                                navigate("/rate-settings");
                            }}
                        >
                            <NavText>Default Rate Settings</NavText>
                        </NavItem>
                        <NavItem
                            eventKey="AdminEmailLists"
                            onClick={()=>{
                                navigate("/email-lists");
                            }}
                        >
                            <NavText>Admin Email Lists</NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem
                        eventKey="EmployeeProfile"
                        onClick={()=>{
                            navigate("/employee-profile");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faUser} />
                        </NavIcon>
                        <NavText>
                            {currentUser?.email}
                        </NavText>
                    </NavItem>
                    <NavItem
                        eventKey="EmployeeDeletedItems"
                        onClick={()=>{
                            navigate("/deleted-items");
                        }}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faTrashCan} />
                        </NavIcon>
                        <NavText>
                            Deleted Items
                        </NavText>
                    </NavItem>

                    <NavItem eventKey=""></NavItem>

                    <NavItem
                        eventKey="EmployeeLogin"
                        onClick={handleLogout}
                    >
                        <NavIcon>
                            <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faSignOutAlt} />
                        </NavIcon>
                        <NavText>
                            Log Out
                        </NavText>
                    </NavItem>
                </SideNav.Nav>
            </SideNav>
        </>
    )
}
